export default {
  advertising: () => import("C:/FE02/_work/305/s/Gallery/layouts/advertising.vue").then(m => m.default || m),
  "dashboard-dark": () => import("C:/FE02/_work/305/s/Gallery/layouts/dashboard-dark.vue").then(m => m.default || m),
  "dashboard-light": () => import("C:/FE02/_work/305/s/Gallery/layouts/dashboard-light.vue").then(m => m.default || m),
  default: () => import("C:/FE02/_work/305/s/Gallery/layouts/default.vue").then(m => m.default || m),
  external: () => import("C:/FE02/_work/305/s/Gallery/layouts/external.vue").then(m => m.default || m),
  light: () => import("C:/FE02/_work/305/s/Gallery/layouts/light.vue").then(m => m.default || m),
  login: () => import("C:/FE02/_work/305/s/Gallery/layouts/login.vue").then(m => m.default || m),
  registration: () => import("C:/FE02/_work/305/s/Gallery/layouts/registration.vue").then(m => m.default || m)
}